// ===================================================================
// Googlemap
// ===================================================================
var currentInfoWindow = null;
function initialize() {
	var latlng1 = new google.maps.LatLng(35.69032211078414,139.7841358377344);
	//　スタイルの指定
	var styles1 = [
		{stylers: [
			{ "saturation": -100 },
			{ "lightness": 0 },
			{ "gamma": 1.5 }
		]
		}
	];


	var myOptions1 = {
		zoom: 17,
		scrollwheel: false,
		draggable: true,
		center: latlng1,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: styles1
	};


	var map1 = new google.maps.Map(document.getElementById("gmap_canvas"), myOptions1);

	//　オリジナル画像のマーカー読み込み
	var makerImg1 = {
		url : template_url + '/assets/images/common/map-pin.png',
		scaledSize : new google.maps.Size(200,61)
	}

	//　オリジナル画像マーカーの表示
	var markerA = new google.maps.Marker({
		position: new google.maps.LatLng(35.69032211078414,139.7841358377344),
		map: map1,
		animation: google.maps.Animation.DROP,
		icon: makerImg1,
		title:"クリックで移動します"
	});

	//　必ずセンター寄せに戻る
	//google.maps.event.addListener(map1, 'center_changed', function() {
    //window.setTimeout(function() {
    //map1.panTo(markerA.getPosition());
	//}, 500);
	//});

	//　クリックしたらmarkerへ移動させる
	google.maps.event.addListener(markerA, 'click', function() {
		var movePos = new google.maps.LatLng(35.69032211078414,139.7841358377344);
		map1.panTo(movePos);
	});
}

google.maps.event.addDomListener(
	window,
	'load',
	initialize
);
